import type { RequestState } from '@qcdoc/shared/redux/requests.ts';
import { requestKey } from '@qcdoc/shared/redux/requests.ts';
import type { VendorDashboardData } from '@qcdoc/shared/services/repositories/vendorDashboardService.ts';
import { createSlice } from '@reduxjs/toolkit';
import { fetchVendorDashboard } from '../thunks/vendorDashboardThunks.ts';

export interface VendorDashboardState {
  lists: Record<string, RequestState<VendorDashboardData>>;
}

export const initialVendorDashboardState: VendorDashboardState = { lists: {} };

const slice = createSlice({
  name: 'vendorDashboard',
  initialState: initialVendorDashboardState,
  reducers: { resetVendorDashboardState: () => initialVendorDashboardState },
  extraReducers: builder => {
    builder.addCase(fetchVendorDashboard.pending, (state, action) => {
      const previous = state.lists[requestKey(action.meta.arg ?? null)];
      state.lists[requestKey(action.meta.arg ?? null)] = { ...previous, status: 'pending', requestId: action.meta.requestId, error: undefined, updatedAt: previous?.updatedAt ?? 0, revision: previous?.revision ?? 0 };
    });
    builder.addCase(fetchVendorDashboard.fulfilled, (state, action) => {
      const request = state.lists[requestKey(action.meta.arg ?? null)];
      if (request?.requestId !== action.meta.requestId) return;
      request.status = 'fulfilled';
      request.requestId = undefined;
      request.error = undefined;
      request.data = action.payload;
      request.updatedAt = Date.now();
    });
    builder.addCase(fetchVendorDashboard.rejected, (state, action) => {
      const request = state.lists[requestKey(action.meta.arg ?? null)];
      if (request?.requestId !== action.meta.requestId) return;
      request.status = action.meta.aborted ? 'idle' : 'rejected';
      request.requestId = undefined;
      request.error = action.meta.aborted ? undefined : { message: action.payload ?? action.error.message ?? 'Dashboard request failed.' };
    });
  },
});

export const { resetVendorDashboardState } = slice.actions;
export default slice.reducer;
